<template>
  <div class="cooperative-school">
    <div style="overflow: hidden;">
      <el-form style="float: left" size="mini" :inline="true">
        <el-form-item label="下单日期">
          <el-date-picker style="width: 320px;" v-model="ruleForm1.buy_date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start"></el-date-picker>
        </el-form-item>

        <el-form-item label="订单类型">
          <el-select size="mini" v-model="ruleForm1.buy_type" placeholder="请选择" style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="存储空间" value="1"></el-option>
            <el-option label="流量" value="2"></el-option>
            <el-option label="时长" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="search1">查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="CreateOrder1" type="primary">新建订单</el-button>
        </el-form-item>
      </el-form>
      <el-button style="float: right" size="mini" round type="info" @click="AddPrincipal1">继续添加校长<i class="el-icon-d-arrow-right el-icon--right"></i></el-button>
    </div>
    <div class="table-style">
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column width="50" align="center" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" prop="schoolName" label="校区名称"></el-table-column>

        <el-table-column width="100" align="left" label="订单类型">
          <template slot-scope="scope">
            <span v-if="scope.row.buy_type == '1'">存储空间</span>
            <span v-else-if="scope.row.buy_type == '2'">流量</span>
            <span v-else-if="scope.row.buy_type == '3'">时长</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="left" label="购买数量">
          <template slot-scope="scope">
            <span v-if="scope.row.buy_type == '1' || scope.row.buy_type == '2'">
              <span v-if="scope.row.buy_num >= 1024 && scope.row.buy_num < 1048576">
                {{ parseFloat(scope.row.buy_num / 1024).toFixed(2) }}
                MB
              </span>
              <span v-else-if="scope.row.buy_num < 1024">{{ scope.row.buy_num }} KB
              </span>
              <span v-else>
                {{ parseFloat(scope.row.buy_num / 1024 / 1024).toFixed(2) }}
                GB
              </span>
            </span>

            <span v-else-if="scope.row.buy_type == '3'">{{ scope.row.buy_num }}天</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="left" prop="unit_price" label="购买单价(元)"></el-table-column>

        <el-table-column width="100" align="left" prop="total_amount" label="总金额(元)"></el-table-column>

        <el-table-column width="150" align="left" prop="pay_date" label="下单时间"></el-table-column>

        <el-table-column width="150" align="left" prop="remarks" label="备注"></el-table-column>

        <el-table-column width="200" align="left" prop="created_time" label="录入时间"></el-table-column>
        <el-table-column align="left" prop="" label="操作人">
          <template slot-scope="scope">
            <span v-if="scope.row.authUserRealname">{{
              scope.row.authUserRealname
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <i class="el-icon-delete" style="margin: 10px; cursor: pointer" @click="adminDeleteSchoolOrder1(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange1" :current-page.sync="page_no" :page-size="20" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
    <el-dialog :title="schoolId ? '修改合作学校' : '新增合作学校'" :visible.sync="dialogVisible" width="60%">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="二级域名" required prop="domain">
          <el-input placeholder="请输入二级域名" v-model="form.domain" style="width: 400px">
          </el-input>
        </el-form-item>
        <el-form-item label="截止日期" required prop="off_time">
          <el-date-picker v-model="form.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
        </el-form-item>

        <el-form-item label="最大分校数" required prop="max_campus_num">
          <el-input-number v-model="form.max_campus_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大教师数" required prop="max_teacher_num">
          <el-input-number v-model="form.max_teacher_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大学生数" required prop="max_student_num">
          <el-input-number v-model="form.max_student_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="地区信息">
          <myDistrict :province.sync="form.province" :city.sync="form.city" :area.sync="form.area"></myDistrict>
        </el-form-item>

        <el-form-item label="客户标签">
          <el-select v-model="form.tagIds" multiple placeholder="请选择">
            <el-option v-for="item in schoolTagList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input placeholder="请输入学校备注" v-model="form.remarks" style="width: 400px">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog1">取 消</el-button>
        <el-button size="small" type="primary" @click="submit1('form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="80%">
      <el-form ref="form" label-width="120px" class="form-style" :model="form" size="small">
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="学校名称" required>
                <el-input v-model="ruleForm.educational_institution_name" style="width: 250px" placeholder="请输入学校名称" disabled @change="DeleteSchool"></el-input>
                <el-button icon="el-icon-plus" @click="ChooseSchool" :disabled="$route.query.id"></el-button>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="产品类型" required>
                <el-radio v-model="ruleForm.buy_type" label="1" @change="changeType(1)">空间(GB)</el-radio>
                <el-radio v-model="ruleForm.buy_type" label="2" @change="changeType(2)">流量(GB)</el-radio>
                <el-radio v-model="ruleForm.buy_type" label="3" @change="changeType(3)">时长(天)</el-radio>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6" v-if="ruleForm.buy_type === '1' || ruleForm.buy_type === '2'">
            <div class=" grid-content bg-purple">
              <span>购买数量</span>
              <el-input-number style="margin-left: 10px" size="mini" v-model="ruleForm.buy_num"></el-input-number>
              <span style="margin-left: 10px">G</span>
            </div>
          </el-col>
          <el-col :span="12" v-if="ruleForm.buy_type === '3'">
            <div>
              <el-form-item label="下单日期" required>
                <el-date-picker type="datetime" placeholder="请选择下单日期" v-model="ruleForm.pay_date" style="width: 300px" value-format="yyyy-MM-dd HH:mm:ss" placement="bottom-start"></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="ruleForm.buy_type === '3'">
            <div>
              <el-form-item label="购买数量" required>
                <el-input-number @input="$forceUpdate()" v-model="ruleForm.buy_num2" style="width: 300px" placeholder="请输入购买数量"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12" v-if="ruleForm.buy_type === '3'">
            <div>
              <el-form-item label="购买单价">
                <el-input-number v-model="ruleForm.unit_price" style="width: 300px" placeholder="总价 / (购买单价 * 365)" disabled :precision="2"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row v-if="ruleForm.buy_type === '3'">
          <el-col :span="12">
            <div>
              <el-form-item label="赠送天数" required>
                <el-input-number v-model="ruleForm.buy_num1" style="width: 300px" placeholder="请输入赠送数量"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="购买总价" required>
                <el-input-number v-model="ruleForm.total_price" style="width: 300px" placeholder="请输入购买总价" :precision="2"></el-input-number>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row v-if="ruleForm.buy_type === '3'">
          <el-col :span="12">
            <div>
              <el-form-item label="购买总数" required>
                <el-input-number v-model="ruleForm.buy_num3" style="width: 300px" placeholder="请输入购买总价" :precision="2" disabled></el-input-number>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="备注信息">
                <el-input style="width: 300px" type="textarea" v-model="ruleForm.remarks"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="6">
            <div class="grid-content bg-purple">
              <span>购买类型</span>
              <el-select size="mini" v-model="ruleForm.buy_type" placeholder="请选择"
                style="width: 150px; margin-left: 10px">
                <el-option label="存储空间" value="1"></el-option>
                <el-option label="流量" value="2"></el-option>
              </el-select>
            </div>
          </el-col> -->
        </el-row>

        <!-- <el-row>
        <el-col :span="24">
          <div style="text-align: right">
            <span style="font-size: 20px">购买总数:</span>
            <span style="
                color: #ea6d03;
                font-size: 20px;
                font-weight: 500;
                margin-left: 10px;
                margin-right: 10px;
              ">{{this.ruleForm.buy_num}}</span>
            <span style="font-size: 20px">元</span>
          </div>
        </el-col>
      </el-row> -->
      </el-form>

      <!-- <el-row>
        <el-col :span="24">
          <div style="text-align: center; margin: 20px">
            <el-button size="small" type="primary" icon="el-icon-s-claim"
              @click="adminAddOrUpdateSchoolOrder">录入订单</el-button>
          </div>
        </el-col>
      </el-row> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="adminAddOrUpdateSchoolOrder">确 定</el-button>
        <!-- <el-button type="primary" @click="godownload">下载中心</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="选择学校" :visible.sync="dialogVisible1" width="80%" top="10vh">
      <el-form size="mini" :inline="true">
        <el-form-item label="学校名称">
          <el-input placeholder="请输入学校名称" v-model="form1.educational_institution_name">
          </el-input>
        </el-form-item>
        <el-form-item label="平台账号">
          <el-input placeholder="请输入平台账号" v-model="form1.username">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="search" type="primary">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="table-style">
        <el-table size="mini" :data="tableData1" highlight-current-row @current-change="CurrentSchool" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column width="50" align="center" prop="id" label="序号" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 + 20 * (page_no1 - 1) }}
            </template>
          </el-table-column>

          <el-table-column width="200" prop="name" align="left" label="校区名称" fixed="left">
          </el-table-column>

          <el-table-column width="150" align="left" label="二级域名" prop="domain">
          </el-table-column>

          <el-table-column width="200" align="left" label="地区">
            <template slot-scope="scope">
              <span>{{ scope.row.province }}-</span><span>{{ scope.row.city }}-</span><span>{{ scope.row.area }}</span>
            </template>
          </el-table-column>

          <el-table-column width="200" align="left" label="超管信息">
            <template slot-scope="scope">
              <span v-for="item of scope.row.principalList" :key="item.id">
                <span>{{ item.realname }}</span>
                <span>{{ '(' + item.name + ')' }}</span>
              </span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="left" label="已用空间">
            <template slot-scope="scope">
              <span v-if="
                  scope.row.use_storage >= 1024 &&
                    scope.row.use_storage < 1048576
                ">
                {{ parseFloat(scope.row.use_storage / 1024).toFixed(2) }}
                MB
              </span>
              <span v-else-if="scope.row.use_storage < 1024">{{ scope.row.use_storage }} KB
              </span>
              <span v-else>
                {{ parseFloat(scope.row.use_storage / 1024 / 1024).toFixed(2) }}
                GB
              </span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="left" label="总空间">
            <template slot-scope="scope">
              <span v-if="
                  scope.row.total_storage >= 1024 &&
                    scope.row.total_storage < 1048576
                ">
                {{ parseFloat(scope.row.total_storage / 1024).toFixed(2) }}
                MB
              </span>
              <span v-else-if="scope.row.total_storage < 1024">{{ scope.row.total_storage }} KB
              </span>
              <span v-else>
                {{
                  parseFloat(scope.row.total_storage / 1024 / 1024).toFixed(2)
                }}
                GB
              </span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="left" label="剩余流量">
            <template slot-scope="scope">
              <span v-if="
                  scope.row.remain_traffic >= 1024 &&
                    scope.row.remain_traffic < 1048576
                ">
                {{ parseFloat(scope.row.remain_traffic / 1024).toFixed(2) }}
                MB
              </span>
              <span v-else-if="scope.row.remain_traffic < 1024">{{ scope.row.remain_traffic }} KB
              </span>
              <span v-else>
                {{
                  parseFloat(scope.row.remain_traffic / 1024 / 1024).toFixed(2)
                }}
                GB
              </span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="left" label="客户标签">
            <template slot-scope="scope">
              <el-tag size="mini" v-for="item in scope.row.schoolTagArr" :key="item.id" :color="item.tagInfo.color">
                <span style="color: white">{{ item.tagInfo.name }}</span>
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column width="80" align="center" label="题库权限">
            <template slot-scope="scope">
              <el-tag size="mini" type="success" effect="dark" v-if="scope.row.question_bank_permission"></el-tag>
              <el-tag size="mini" v-else type="info" effect="dark"></el-tag>
            </template>
          </el-table-column>

          <el-table-column width="180" align="left" prop="remarks" label="备注"></el-table-column>

          <el-table-column width="150" align="left" prop="off_time" label="到期时间"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no1" :page-size="page_size1" layout="total, prev, pager, next" :total="total1"></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="CancelChoose">取消</el-button>
        <el-button size="small" type="primary" @click="SubmitChoose">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEducationalInstitutionList,
  addEducationalInstitution,
  updateEducationalInstitution,
  getPrincipalUserList,
  adminGetSchoolTagList,
  adminGetSchoolOrderList,
  adminDeleteSchoolOrder,
} from '@/api/admin'

import myDistrict from '../../../../components/myDistrict/myDistrict.vue'
import { adminAddOrUpdateSchoolOrder } from '@/api/admin'

import { Daysdiff, shortTime } from '@/config/utils'
export default {
  name: 'look-order',
  data() {
    return {
      num1: 0,
      //页码管理
      page_no1: 1,
      page_size1: 10,
      total1: 0,

      dialogVisible1: false,

      //订单录入参数

      ruleForm: {
        schoolId: '',
        username: '',
        educational_institution_name: '',
        total_price: 0,
        buy_num: 0,
        buy_num3: 3,

        buy_num1: 0,
        buy_num2: 0,
        remarks: '',
        pay_date: '', //下单时间
        buy_type: '1',
      },
      tableData1: [], //学校列表

      form1: {
        educational_institution_name: '',
        username: '',
      },
      formInline: {},

      dialogVisible2: false,
      userList: [],
      dialogVisible: false,
      ruleForm1: {
        buy_type: '',
        educational_institution_name: '',
        buy_date: [],
      },
      form: {
        schoolId: '',

        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
      },
      schoolId: '',
      schoolTagList: [], //标签页面
      tableData: [],
      total: 0,
      page_no: 1,
      rules: {
        educational_institution_name: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur',
          },
        ],
        domain: [
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'blur',
          },
        ],
        off_time: [
          { required: true, message: '请选择系统截止日期', trigger: 'change' },
          { required: true, message: '请选择系统截止日期', trigger: 'blur' },
        ],
      },
    }
  },

  components: { myDistrict },
  watch: {
    sum: {
      handler: function (val) {
        console.log(val, 2225)
        this.ruleForm.buy_num3 = val
      },
      deep: true,
    },
    unit: {
      handler: function (val) {
        console.log(val, 2225)
        if (this.ruleForm.buy_num2 === 0) {
          this.ruleForm.unit_price = 0
        } else {
          this.ruleForm.unit_price = val
        }
        // if (isNaN(val)) {
        //   this.ruleForm.unit_price = 0
        // } else {
        //   this.ruleForm.unit_price = val
        // }

        // if(val === NaN){
        // this.ruleForm.unit_price = 0
        // }else{
        // this.ruleForm.unit_price = val

        // }
      },
      deep: true,
    },
  },
  computed: {
    // total_amount: function () {
    //   return (
    //     parseFloat(this.ruleForm.total_price) * parseFloat(this.ruleForm.unit_price)
    //   );
    // },
    unit: function () {
      return (
        parseFloat(this.ruleForm.total_price) /
        parseFloat(this.ruleForm.buy_num2 * 365)
      )
    },
    sum: function () {
      return (
        Number(this.ruleForm.buy_num2) * 365 + Number(this.ruleForm.buy_num1)
      )
    },
  },

  mounted() {
    this.adminGetSchoolOrderList1()
    if (this.$route.query.id) {
      this.ruleForm.educational_institution_name = this.$route.query.name
    } else {
      this.$message.warning('请选择校区')
      this.$router.push({
        name: 'cooperative-school',
      })
    }
  },
  methods: {
    // godownload() {
    //   console.log("下载中心");
    //   this.$router.push({
    //     name: "download-management",
    //     query: {
    //       id: this.$route.query.id
    //     }
    //   });
    // },
    GogoSchool(domain) {
      console.log('二级域名跳转')
      console.log(domain)
    },

    search() {
      this.page_no1 = 1
      this.getEducationalInstitutionList()
    },

    //校区新建空间和流量订单

    adminAddOrUpdateSchoolOrder() {
      console.log('提交订单参数')
      console.log(this.ruleForm)

      if (!this.$route.query.id) {
        if (!this.ruleForm.schoolId) {
          this.$message.warning('请选择校区')
          return
        }
      }

      // if (!this.ruleForm.pay_date) {
      //   this.$message.warning("请选择下单日期");
      //   return;
      // }

      this.$confirm('确定提交订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        var unit = 1
        if (this.ruleForm.buy_type == '1' || this.ruleForm.buy_type == '2') {
          adminAddOrUpdateSchoolOrder({
            schoolId: this.$route.query.id
              ? this.$route.query.id
              : this.ruleForm.schoolId,
            buy_type: this.ruleForm.buy_type,
            buy_num: this.ruleForm.buy_num * 1024 * 1024,
            unit_price: 0,
            total_amount: 0,
            remarks: '',
          }).then((res) => {
            console.log('校区订单')
            console.log(res)
            if (res.is_created) {
              this.$message.success('购买成功')
              this.dialogVisible2 = false
              this.adminGetSchoolOrderList1()
            }
          })
        } else if (this.ruleForm.buy_type == '3') {
          unit = 1
          adminAddOrUpdateSchoolOrder({
            schoolId: this.$route.query.id
              ? this.$route.query.id
              : this.ruleForm.schoolId,
            buy_type: this.ruleForm.buy_type,
            buy_num: this.ruleForm.buy_num3 * unit,
            unit_price: this.ruleForm.unit_price,
            pay_date: this.ruleForm.pay_date,
            total_amount: this.ruleForm.total_price,
            remarks: this.ruleForm.remarks,
          }).then((res) => {
            console.log('校区订单')
            console.log(res)
            if (res.is_created) {
              this.$message.success('购买成功')
              // this.$router.push({ name: "look-order" });
              this.dialogVisible2 = false
              this.adminGetSchoolOrderList1()
            }
          })
        }
      })
    },

    CurrentChange_School(val) {
      console.log('选择了学校')
      console.log(val)
      this.chooseSchool_current = val
    },

    CancelChoose() {
      this.dialogVisible1 = false
      console.log('取消选择学校')
      this.chooseSchool = {}
    },

    SubmitChoose() {
      this.dialogVisible1 = false
    },

    goBack() {
      this.$router.push({ name: 'look-order' })
    },

    //选择学校
    ChooseSchool() {
      console.log('选择学校')
      this.dialogVisible1 = true
      this.getEducationalInstitutionList()
    },

    // 获取合作学校列表
    getEducationalInstitutionList() {
      getEducationalInstitutionList({
        educational_institution_name: this.form1.educational_institution_name,
        username: this.form1.username,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('校区列表')
        console.log(res)
        this.tableData1 = res.educational_institution_list
        this.total = res.total1
      })
    },

    handleCurrentChange(val) {
      this.page_no1 = val
      this.getEducationalInstitutionList()
    },
    //已选择的学校
    CurrentSchool(val) {
      console.log(val)

      var remain_days = Daysdiff(val.off_time, shortTime(new Date()))
      this.ruleForm.educational_institution_name =
        val.name + '(剩余' + remain_days + '天)'
      this.ruleForm.schoolId = val.id
    },

    // //计算付费总金额
    // ComputedTotalPrice() {
    //   this.ruleForm.total_price =
    //     this.ruleForm.buy_num * this.ruleForm.unit_price;
    // },
    //
    DeleteSchool() {
      console.log('学校名称改变')
      console.log(this.ruleForm.educational_institution_name)
      if (this.ruleForm.educational_institution_name == '') {
        this.ruleForm.schoolId = ''
      }
    },

    //////////////////////////////////

    AddPrincipal1() {
      this.$router.push({
        name: 'principal-management',
        query: {
          id: this.$route.query.id,
          name: this.$route.query.name,
          domain: this.$route.query.domain,
        },
      })
    },
    //查询校区订单
    adminGetSchoolOrderList1() {
      adminGetSchoolOrderList({
        schoolId: this.$route.query.id,
        buy_type: this.ruleForm1.buy_type,
        start_date: this.ruleForm1.buy_date[0],
        end_date: this.ruleForm1.buy_date[1],
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('校区订单')
        console.log(res)

        this.tableData = res.schoolOrderList
        this.total = res.total
      })
    },

    //查询校区标签
    adminGetSchoolTagList() {
      adminGetSchoolTagList().then((res) => {
        console.log('查询校区标签')
        console.log(res)
        this.schoolTagList = res.schoolTagList
      })
    },

    // 获取校长账号列表
    getPrincipalUserList() {
      getPrincipalUserList({
        page_size: 200,
      }).then((res) => {
        this.userList = res.principal_user_list
      })
    },
    quitDialog1() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    search1() {
      this.page_no = 1
      this.adminGetSchoolOrderList1()
    },
    submit1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.schoolId) {
            updateEducationalInstitution({
              educational_institution_id: this.schoolId,
              educational_institution_name: this.form
                .educational_institution_name,
              domain: this.form.domain,
              max_campus_num: this.form.max_campus_num,
              max_teacher_num: this.form.max_teacher_num,
              max_student_num: this.form.max_student_num,
              off_time: this.form.off_time,
              remarks: this.form.remarks,
              tagIds: JSON.stringify(this.form.tagIds),
              province: this.form.province,
              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('修改学校信息')
              console.log(res)
              if (res.is_update) {
                this.$message.success('修改成功')
                this.quitDialog1()
                this.getEducationalInstitutionList1()
              }
            })
          } else {
            console.log('新建校区参数')
            console.log(this.form)
            addEducationalInstitution({
              name: this.form.educational_institution_name,
              domain: this.form.domain,
              authMealId: this.form.meal_id,
              max_campus_num: this.form.max_campus_num,
              max_teacher_num: this.form.max_teacher_num,
              max_student_num: this.form.max_student_num,
              off_time: this.form.off_time,
              remarks: this.form.remarks,
              tagIds: JSON.stringify(this.form.tagIds),
              province: this.form.province,
              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('新增合作校区')
              console.log(res)
              if (res.is_create) {
                this.$message.success('添加合作学校成功')
                this.quitDialog1()
                this.getEducationalInstitutionList1()
              }
            })
          }
        }
      })
    },
    // 获取合作学校列表
    getEducationalInstitutionList1() {
      getEducationalInstitutionList({
        educational_institution_name: this.ruleForm1
          .educational_institution_name,
        username: this.ruleForm1.username,
        page_no: this.page_no,
      }).then((res) => {
        console.log('校区列表')
        console.log(res)
        this.tableData = res.educational_institution_list
        this.total = res.total
      })
    },

    // GogoSchool(domain) {
    //   console.log("二级域名跳转");
    //   console.log(domain);
    // },

    handleCurrentChange1(val) {
      this.page_no = val
      this.adminGetSchoolOrderList1()
    },
    changeType(val) {
      console.log(val, 12122)
      console.log(this.ruleForm.buy_num3, 12122)
      console.log(this.ruleForm.buy_num, 12122)

      if (val === '1') {
        this.ruleForm.buy_num = 0
        this.ruleForm.buy_num2 = 0
        this.ruleForm.buy_num1 = 0
      }
      if (val === '2') {
        this.ruleForm.buy_num = 0
        this.ruleForm.buy_num2 = 0
        this.ruleForm.buy_num1 = 0
      }
      if (val === '3') {
        this.ruleForm.buy_num = 0
        this.ruleForm.buy_num2 = 0
        this.ruleForm.buy_num1 = 0
      }
    },
    //新建订单
    CreateOrder1() {
      console.log('新建订单')
      this.dialogVisible2 = true
      this.ruleForm.buy_type = '1'
      this.ruleForm.buy_num = '0'
      this.ruleForm.buy_num2 = 0
      this.ruleForm.buy_num1 = 0
      this.ruleForm.total_price = 0
      // this.ruleForm.buy_num2 = '0'
      // this.ruleForm.buy_num1 = '0'

      if (this.$route.query.id) {
        this.ruleForm.educational_institution_name = this.$route.query.name
      }

      // console.log(this.$route.query.id, 121541);

      // this.$router.push({ name: "create-order" });
      // this.$router.push({
      //   name: "create-order",
      //   query: {
      //     id: this.$route.query.id,
      //     name: this.$route.query.name
      //   }
      // });
    },

    //删除订单
    adminDeleteSchoolOrder1(row) {
      console.log('删除校区订单')

      this.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminDeleteSchoolOrder({
          schoolOrderId: row.id,
        }).then((res) => {
          console.log('删除校区订单返回')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.adminGetSchoolOrderList1()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cooperative-school {
  padding: 20px;
  margin: 10px;
  background-color: #fff;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .btn {
    margin-top: 15px;
  }
}
</style>
